import React from 'react';
import { View } from 'react-native';
import {
  lessonGeneratorEmbedStyles,
  LessonGeneratorEmbedProps,
} from './lessonGeneratorEmbedShared';

/**
 * Web-only: iframe embed (avoids bundling react-native-webview on web).
 */
const LessonGeneratorEmbed: React.FC<LessonGeneratorEmbedProps> = ({
  uri,
  containerStyle,
}) => {
  if (!uri?.trim()) return null;

  const iframe = React.createElement('iframe', {
    src: uri,
    title: 'Lesson generator',
    allow: 'clipboard-write; fullscreen',
    loading: 'lazy' as const,
    style: {
      border: 'none',
      width: '100%',
      height: '100%',
      borderRadius: 10,
      display: 'block',
    },
  });

  return (
    <View style={[lessonGeneratorEmbedStyles.wrapper, containerStyle]}>
      {iframe}
    </View>
  );
};

export default LessonGeneratorEmbed;
